import { Grid, Table, TableCell, TableRow, TableHead, TableBody, Typography, TablePagination, TableFooter } from "@material-ui/core";
import { useContext } from "react"
import Moment from "react-moment";
import { ticketContext } from "views/Ticket/TicketContext";


let Activities = () => {
    let { activities, search, recordCount, changePage } = useContext(ticketContext)


    return (
        <Grid container>
            <Grid item xs>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Description</TableCell>
                            <TableCell>By</TableCell>
                            <TableCell>On</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {activities.map((activity, i) =>
                            <TableRow key={activity.date + activity.author + i}>
                                <TableCell>{activity.message}</TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }}>{activity.author}</TableCell>
                                <TableCell style={{ whiteSpace: 'nowrap' }}>
                                    <Moment date={activity.date} format="L LT" />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {recordCount === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={3}><i>No Activity were found</i></TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
                <TablePagination
                    rowsPerPageOptions={[search.pageSize]}
                    component="div"
                    count={recordCount}
                    rowsPerPage={search.pageSize}
                    page={search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={(e, page) => changePage(page)}
                    labelDisplayedRows={({ page }) =>
                        <span>Found {recordCount} activities&nbsp;&middot;&nbsp;page {page + 1} of {Math.ceil(recordCount / search.pageSize)}</span>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default Activities